import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { ThemePalette, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MachineDB_controller } from 'src/app/Services/DB_Controller/MachineDB_controller';
import { PartDB_controller } from 'src/app/Services/DB_Controller/PartDB_controller';
import { PODB_controller } from 'src/app/Services/DB_Controller/PODB_controller';
import { Machine } from 'src/app/Services/Object_Classes/Machine/Machine';
import { Part } from 'src/app/Services/Object_Classes/Part/Part';
import { PurchaseOrder, PartTracker } from 'src/app/Services/Object_Classes/PurchaseOrder/PurchaseOrder';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { ViewRawMaterialsComponent } from 'src/app/Shared/view-raw-materials/view-raw-materials.component';
import { SelectMachineSlotComponent } from '../../scheduling/add-event/select-machine-slot/select-machine-slot.component';
import { v4 as uuidv4 } from 'uuid';
import { AngularFirestore } from '@angular/fire/firestore';
import { Customer } from 'src/app/Services/Object_Classes/Customer/Customer';
import { CustomerDB_controller } from 'src/app/Services/DB_Controller/CustomerDB_controller';
import { AddPartComponent } from '../../parts/PopUpModal/add-part/add-part.component';
import { StaffDB_controller } from 'src/app/Services/DB_Controller/StaffDB_controller';
import { Staff } from 'src/app/Services/Object_Classes/Staff/Staff';
import { WeightingDB_controller } from 'src/app/Services/DB_Controller/WeightingDB_controller';
import { AddConfirmationComponent } from '../add-confirmation/add-confirmation.component';

@Component({
  selector: 'app-add-qc',
  templateUrl: './add-qc.component.html',
  styleUrls: ['./add-qc.component.css']
})
export class AddQCComponent implements OnInit {

  inspectionTypes = ['Incoming Inspection', 'In-process Inspection', 'Out-going Inspection', 'First Article Inspection'];

  inspectionNo = 0;
  poNo: any;
  joNo: any;
  totalPart: any;
  partNumber: any;
  quantity: any;
  part: Part = new Part();
  part_controller: PartDB_controller = new PartDB_controller(this.db,this.storage,this.firestore);
  po_controller: PODB_controller = new PODB_controller(this.db);
  CustomerDB_controller: CustomerDB_controller = new CustomerDB_controller(this.db,this.firestore);
  StaffDB_controller: StaffDB_controller = new StaffDB_controller(this.db, this.firestore);
  weighting_Controller = new WeightingDB_controller(this.db);
  partlist: Part[] = [];
  matSelectCustomer: Customer[] = [];
  customerlist: Customer[] = [];
  matSelectPart: Part[] = [];
  clone = [];
  runningScheduleList = [];
  estimateTotalTime = [];
  choosingPart= [];
  timeslots = [];
  dateslots = [];
  addForm: FormGroup;
  newPO: PurchaseOrder = new PurchaseOrder();
  newPO_PartList: PartTracker[] = [];
  searchPart: any;
  email: string;
  existingName = false;
  customerName = '';
  staffName = '';
  check = false;
  Staff: Staff[] = [];
  CloneStaff: Staff[] = [];
  @ViewChild('picker', {static: true}) picker: any;

  public date: moment.Moment;
  public minDate: moment.Moment;
  public maxDate: moment.Moment;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';

  public formGroup = new FormGroup({
    date: new FormControl(null, [Validators.required]),
    date2: new FormControl(null, [Validators.required])
  });

  public options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  constructor(
    private dialogRef: MatDialogRef<AddQCComponent>,
    private fb: FormBuilder,
    private toast: ToastrService,
    private db: AngularFireDatabase,
    private storage: AngularFireStorage,
    private dialog: MatDialog,
    private angularFireAuth: AngularFireAuth,
    private firestore: AngularFirestore,
    private spinner : NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.addForm = this.fb.group({
      inspectType: 'Out-going Inspection',
      customerName: data.customerName,
      soNumber: data.SO_No,
      drawingNo: data.Part_No,
      partName: data.Part_Name,
      partNo: data.Part_No,
      rev: '',
      inspectBy: '',
      quantity: data.PO_Qty,
      lotSize: '',
      parts: this.fb.array([]),
    });

    this.angularFireAuth.authState.subscribe(auth=>{
      this.email = auth.email;

      this.StaffDB_controller.searchStaffbyEmail(this.email).then(data => {
        if(data && data.StaffName != null){
          this.addForm.controls['inspectBy'].setValue(data.StaffName);
        }
      });
    });

    this.joNo = data.JO_No;
    this.inspectionNo = parseInt(data.Inspect_Qty);
    //this.addParts();
  }
  
  async nameValidation() {
    const name = this.addForm.get('name').value.trim();
    if (name.includes('/') || name.includes('@') || name.includes('[')  || name.includes(']')  || name.includes('.')  || name.includes('#')  || name.includes('$') || name.includes('*')) {
      this.existingName = true
    }
    else{
      var snapshot = await this.db.database.ref('Purchase Order/' + name).once('value');
      if (snapshot.exists()) {
        this.existingName = true;
      }
      else {
        this.existingName = false;
        this.poNo = name;
      }
    }
  }

  ngOnInit() {
    this.spinner.show();
    this.part_controller.getPartList().then(data => {
      this.matSelectPart = data;
      this.clone = this.matSelectPart.slice();
      this.spinner.hide();
    });

    this.CustomerDB_controller.getCustomerList().then(data => {
      this.matSelectCustomer = data;
      this.customerlist = this.matSelectCustomer.slice();
      this.spinner.hide();
    });

    this.StaffDB_controller.getStaffList().then(data => {
      this.Staff = data;
      this.CloneStaff = this.Staff.slice();
      this.spinner.hide();
    });
  }

  parts(): FormArray {
    return this.addForm.get('parts') as FormArray;
  }

  samples(i): FormArray {
    return this.parts().at(i).get('samples') as FormArray;
  }

  newParts(): FormGroup {
    const unit = new FormControl();
    const standard = new FormControl();
    const tolerence = new FormControl();
    const tool = new FormControl();
    let samplesList = new FormArray([]);

    for(var i=0; i<this.inspectionNo; i++){
      samplesList.push(this.newSamples());
    }

    return this.fb.group({
      unit,
      standard,
      tolerence,
      tool,
      samples: samplesList,
    });
  }

  newSamples(): FormGroup {
    const reading = new FormControl();

    return this.fb.group({
      reading
    });
  }

  findPart(part) {
    if (!this.clone) { return; }
    const search = part.value;
    this.matSelectPart = this.clone.filter(p => p.Part_No.toLowerCase().includes(search.toLowerCase()));
  }

  addParts() {
    this.parts().push(this.newParts());
    this.partlist.push(null);
  }

  addSamples(i) {
    this.samples(i).push(this.newSamples());
    //this.partlist.push(null);
  }

  removeParts(i: number) {
    this.parts().removeAt(i);
    this.partlist.splice(i, 1);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  addPart(){
    const dialogRefaddPart = this.dialog.open(AddPartComponent, {
      width: '90%',
      height: '90%'
    });

    var newPart = new Part();
    dialogRefaddPart.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined') {
        newPart = result;
        this.spinner.show();
        this.part_controller.add_or_update_Part(newPart);
        this.toast.success(newPart.Part_Name + " has been added successfully!","Added Successfully");
        this.part_controller.getPartList().then(data => {
          this.matSelectPart = data;
          this.clone = this.matSelectPart.slice();
          this.spinner.hide();
        });
      }
    });
  }

  ChangeDate(index){

  }

  ChangeDate2(index){

  }

  change(cusId){
    this.customerName = cusId;
  }

  change2(cusId){
    this.staffName = cusId;
  }

  confirm() {
    if(this.addForm.get('soNumber').value == null || this.addForm.get('soNumber').value == ''){
      this.toast.error('Please fix SO Name', 'Please change!');
      return;
    }

    if(this.addForm.get('customerName').value == null || this.addForm.get('customerName').value == ''){
      this.toast.error('Please Enter Customer', 'Please enter customer!');
      return;
    }

    if(this.addForm.get('inspectBy').value == null || this.addForm.get('inspectBy').value == ''){
      this.toast.error('Please Enter Inspection Person', 'Please enter staff name!');
      return;
    }

    const addPOModel = {
      inspectType : this.addForm.get('inspectType').value,
      customerName : this.addForm.get('customerName').value,
      soNumber : this.addForm.get('soNumber').value,
      drawingNo : this.addForm.get('drawingNo').value,
      partName : this.addForm.get('partName').value,
      partNo : this.addForm.get('partNo').value,
      rev : this.addForm.get('rev').value,
      inspectBy : this.addForm.get('inspectBy').value,
      quantity : this.addForm.get('quantity').value,
      lotSize : this.addForm.get('lotSize').value,
      joNumber : this.joNo,
      parts: []
    };

    const parts = this.addForm.get('parts').value;
    parts.forEach((element, index) => {
      const info = {
        unit: element.unit,
        standard: element.standard,
        tolerence: element.tolerence,
        tool: element.tool,
        samples: []
      };

      element.samples.forEach((element) => {
        const info2 = {
          reading: element.reading
        };

        if ( !info2.reading ) {
          this.toast.error('Point information(' + (index + 1) + ') not completed!', 'Please fill in');
          return;
        }

        info.samples.push(info2);
      });

      if (info.samples.length === 0) {
        this.toast.error('Please add at least one sample', 'Add part');
        return;
      }

      if ( !info.standard|| !info.tolerence || !info.tool  ) {
        this.toast.error('Point information(' + (index + 1) + ') not completed!', 'Please fill in');
        return;
      }

      addPOModel.parts.push(info);
    });

    if (addPOModel.parts.length === 0) {
      this.toast.error('Please add at least one point', 'Add part');
      return;
    }

    if(addPOModel.parts.length !== this.partlist.length){
      this.toast.error('Form not completed', 'Form');
      return;
    }

    if (!addPOModel.soNumber) {
      this.toast.error('Please fill in the PO name ', 'Please fill in');
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = '80%';
    dialogConfig.width = '50%';
    const position = {
      top: '5%'
    };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = addPOModel;

    this.dialog.open(AddConfirmationComponent, dialogConfig).afterClosed().subscribe(result => {
      if (result) {
        this.weighting_Controller.updateQCWithoutSchedule(addPOModel,this.email);
        this.dialogRef.close(addPOModel);
      }
      else{
        this.dialogRef.close(addPOModel);
      }
    });
  }

  changeLot(){
    if($('#lotSize').val() != null && $('#lotSize').val() != ''){
      this.inspectionNo = parseInt($('#lotSize').val().toString());
    }
  }

  getRandomString(length) {
    let randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for ( let i = 0; i < length; i++ ) {
        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  /*getPart(part,formindex){
    const samePart = this.choosingPart.find(c=>c.part === part && c.index !==formindex);
    
    if(samePart){
      this.toast.warning("Same part number has been ordered, please choose others", "Warning");
      return;
    }

    if (part) {
      this.part_controller.search_Part(part).then(data => {
        this.partlist[formindex] = data;
        const info = {
          part:part,
          index: formindex,
        }
        this.choosingPart.push(info);

      });
    }
  }*/

  getPart(formindex){
    var partNo = $('#partNo').val();
    const samePart = this.matSelectPart.find(c=>c.Part_No === partNo);
    
    if (samePart) {
      this.part_controller.search_Part(partNo.toString()).then(data => {
        this.partlist[formindex] = data;
        const info = {
          part:partNo,
          index: formindex,
        }

        //this.choosingPart.push(info);
      });
    }
  }

  parFloat(value){
    return parseFloat(value);
  }
}
